import { render, staticRenderFns } from "./PracticeList.vue?vue&type=template&id=83e31a1e&"
import script from "./PracticeList.vue?vue&type=script&lang=js&"
export * from "./PracticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports